import { render, staticRenderFns } from "./ScrollDownBtn.vue?vue&type=template&id=6844b578&scoped=true&"
var script = {}
import style0 from "./ScrollDownBtn.vue?vue&type=style&index=0&id=6844b578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844b578",
  null
  
)

export default component.exports